import React from "react";

const ProgressBar = ({ value, max }) => (
  <div className="relative  w-full h-3 bg-gray-300 rounded">
    <div
      className="absolute top-0 left-0 h-full bg-black rounded"
      style={{ width: `${(value / max) * 100}%` }}
    />
  </div>
);

const RatingBar = ({ rating, numReviews, maxReviews }) => (
  <div className="flex flex-col sm:flex-row items-center w-full justify-between py-2">
    <div className="w-full sm:w-2/3 text-gray-700 mb-2 sm:mb-0">{rating}</div>
      <ProgressBar value={numReviews} max={maxReviews} />
    
     <div className="w-full sm:w-1/3 text-gray-700 text-right">
      <span className="hidden sm:inline">{numReviews}</span>
      <span className="sm:hidden">{numReviews > 1000 ? `${numReviews / 1000}k` : numReviews}</span>
    </div>
  </div>
);

const RatingBarChart = ({ data }) => {
  const maxReviews = Math.max(...data.map(({ numReviews }) => numReviews));

  return (
    <div className="bg-[#f5f1f1] rounded  overflow-hidden w-full lg:w-5/12 px-2">
      {data.map(({ rating, numReviews }) => (
        <RatingBar
          key={rating}
          rating={rating}
          numReviews={numReviews}
          maxReviews={maxReviews}
        />
      ))}
    </div>
  );
};




export default RatingBarChart;